import {useFirebaseState} from "./firebaseContext";

export const useIsInstructorOrAdmin = () => {
    const {admin, instructor} = useFirebaseState()
    return admin || instructor
}